import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { changePassword } from '../../services/authService';
import PasswordInput from './PasswordInput';
import './styles/Login.css';

export default function ChangePassword() {
  const { user, loading } = useAuth();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    setError('');

    if (newPassword !== confirm) {
      setError('New passwords do not match.');
      return;
    }

    setBusy(true);
    try {
      const data = await changePassword({ currentPassword, newPassword });
      setMsg(data?.message || 'Password changed successfully.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirm('');
    } catch (e2) {
      setError(e2?.response?.data?.message || 'Failed to change password');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-eyebrow">
            <span className="auth-eyebrow-dot" aria-hidden="true" />
            Account settings
          </div>
          <h2 className="auth-title">Change password</h2>
          <p className="auth-subtitle">Update your password to keep your account secure.</p>
        </div>

        {msg && (
          <div className="auth-alert" role="alert"
            style={{ borderColor: 'rgba(34,197,94,0.25)', background: 'rgba(34,197,94,0.07)', color: 'rgba(187,247,208,0.95)' }}>
            {msg}
          </div>
        )}
        {error && <div className="auth-alert" role="alert">{error}</div>}

        <form className="auth-form" onSubmit={onSubmit} noValidate>
          <PasswordInput
            label="Current password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="Enter your current password"
            required
            disabled={busy}
          />

          <div className="auth-divider" />

          <PasswordInput
            label="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Create a new password"
            required
            disabled={busy}
          />

          <PasswordInput
            label="Confirm new password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Repeat your new password"
            required
            disabled={busy}
          />

          <button className="auth-button" disabled={busy} type="submit">
            {busy ? 'Saving…' : 'Update Password →'}
          </button>
        </form>
      </div>
    </div>
  );
}
